import React from 'react';

const MutliSelectCheckbox = ({ options, onSelect, selectedList, description, classes }) => {
  const changeHandler = (option) => {
    const isSelected = selectedList.some(item => item.name === option.name);
    if (isSelected) {
      onSelect(selectedList.filter(item => item.name !== option.name));
    } else {
      onSelect([...selectedList, option]);
    }
  };

  return (
    <div className={classes}>
        <span>{description}</span>
        {options.map(option => (
        <div key={option.id}>
          <input
            type="checkbox"
            id={option.id}
            name={option.name}
            value={option.name}
            checked={selectedList.some(item => item.name === option.name)}
            onChange={() => changeHandler(option)}
          />
          <label htmlFor={option.id}>{option.name}</label>
        </div>
        ))}
    </div>
  );
};

export default MutliSelectCheckbox;
